export default {
	"pages": {
		"root": {
			"name": "root",
			"children": [
				"642e1facbf72b300207ce174",
				"642e1facbf72b300207ce178",
				"642e1facbf72b300207ce184",
				"642e1facbf72b300207ce180",
				"642e1facbf72b300207ce188"
			],
			"id": "root",
			"pageUrl": "root"
		},
		"642e1facbf72b300207ce174": {
			"id": "642e1facbf72b300207ce174",
			"name": "404",
			"pageUrl": "404"
		},
		"642e1facbf72b300207ce178": {
			"id": "642e1facbf72b300207ce178",
			"name": "index",
			"pageUrl": "index",
			"seo": {
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"title": "Home | Website Example",
				"og:title": "Home | Website Example",
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			}
		},
		"642e1facbf72b300207ce180": {
			"id": "642e1facbf72b300207ce180",
			"seo": {
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"title": "Work | Website Example",
				"og:title": "Work | Website Example",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			},
			"pageUrl": "work",
			"name": "Work"
		},
		"642e1facbf72b300207ce184": {
			"id": "642e1facbf72b300207ce184",
			"seo": {
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"title": "Team | Website Example",
				"og:title": "Team | Website Example"
			},
			"pageUrl": "team",
			"name": "Team"
		},
		"642e1facbf72b300207ce188": {
			"id": "642e1facbf72b300207ce188",
			"pageUrl": "contact",
			"name": "Contact",
			"seo": {
				"og:image": "https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z",
				"title": "Contact | Website Example",
				"og:title": "Contact | Website Example",
				"description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference.",
				"og:description": "It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."
			}
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}